import { useTranslation } from 'react-i18next'

const PlaceholderHelpText = () => {
  const { t } = useTranslation()

  return (
    <div>
      <p>
        {t(
          `Placeholders is used by document templates and helps to ensure, that the templates are flexible and can be used to generate documents for multiple employees, by automatically adjusting to the current situation. E.g. the system placeholder {{employee_first_name}} will input the first name of the employee, if it is used in a template.`,
          { employee_first_name: '{{employee_first_name}}' },
        )}
      </p>
      <h3>{t('How to use placeholders:')}</h3>
      <ol>
        <li>
          {t(
            'Click on the dropdown called "Insert placeholder" in the editor.',
          )}
        </li>
        <li>
          {t(
            'Click on the placeholder you wish to insert. The placeholder will then be placed at the caret position or at the beginning of the document.',
          )}
        </li>
        <li>
          {t(
            'Alternatively, you can type "#" in the editor and select a placeholder from the dropdown.',
          )}
        </li>
      </ol>
      <p>
        {t(
          'It is also possible to add your own placeholders to a document template, by inserting the name you wish to assign to the placeholder between two curly brackets: {{insert_placeholder_name}}. When a document is generated with this template, you will be asked to assign a value to the placeholder.',
          { insert_placeholder_name: '{{insert_placeholder_name}}' },
        )}
      </p>
      <p>
        {t(
          'Besides the placeholders mentioned above, there are four types of placeholders:',
        )}
      </p>
      <h3>{t('System placeholders')}</h3>
      <p>
        {t(
          'These placeholders inserts the core data from the employee, such as name, address, title, email etc.',
        )}
      </p>
      <h3>{t('Predefined placeholders')}</h3>
      <p>
        {t(
          'Predefined placeholders can be created by navigating to Settings > Document templates > Manage placeholders. You must assign a name and a value when creating a predefined placeholder. When the placeholder is used to generate a document, the system will insert the value you defined when the placeholder was created.  ',
        )}
      </p>
      <h3>{t('Custom form fields as placeholders')}</h3>
      <p>
        {t(
          'In Settings >  Document templates > Manage placeholders it is also possible to create a placeholder from a custom form field. When you use these placeholders to generate a document for an employee, the system will take the form field value from the employee and assign it to the placeholder. Only form fields. Only form fields of the types drop-down or text can be used for placeholders. Form fields can be managed in Settings >  Forms',
        )}
      </p>
      <h3>{t('Conditional placeholders')}</h3>
      <p>
        {t(
          'Use these special placeholders to conditionally render a section of text. When generating a document, conditional placeholders are supplied with a true/false value. Conditional placeholders are included if the value is true. It is also possible to specify inverted conditional placeholders. In this case the text is included if the placeholder is supplied with a false value.',
        )}
      </p>
      <p>{t('How to use conditional placeholders:')}</p>
      <ol>
        <li>
          {t(
            'Click on the button called "Insert conditional placeholder" or "Insert inverted conditional placeholder" in the editor.',
          )}
        </li>
        <li>
          {t(
            'A popup will appear asking you for the name of the conditional placeholder. Type in the name you wish to use.',
          )}
        </li>
        <li>
          {t(
            'The conditional placeholder will then be inserted at the caret position or at the beginning of the document.',
          )}
        </li>
      </ol>
      <p>
        {t(
          'Note that if you mark any text before going through the steps above, the conditional placeholder will wrap around the selected text.',
        )}
      </p>
    </div>
  )
}

export default PlaceholderHelpText
